/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Injectable} from '@angular/core';

import {LocalUserProfile} from '../../../components/session/local-user-profile';
import {resolveIntlLocale} from './locale-date-format';

@Injectable({
  providedIn: 'root'
})
export class AppLocaleService {
  constructor(private readonly localUserProfile: LocalUserProfile) {
  }

  getLocaleId(): string {
    return resolveIntlLocale(this.localUserProfile.get('locale') || 'en_GB');
  }
}
